// University selection init
$formSelectUniversity = $("select[id^='reward_form_submission_submission_data_university_name']")
$formSelectUniversity.on('change', function () {
  let selectedUniversityID = $(this).find('option:selected').data("id");
  var universityIDSelector = $(this).attr("id").replace("name", "id")
  $('#' + universityIDSelector).val(selectedUniversityID)
  var majorIDSelector = $(this).attr("id").replace("name", "major")
  $('#' + majorIDSelector).empty()
  loadMajorList(majorIDSelector, selectedUniversityID, false);
})

$formSelectMajorUniversity = $("select[id^='reward_form_submission_submission_data_university_major']")
$formSelectMajorUniversity.on('select2:select', function (e) {
  let selectedMajorID = e.params.data.majorId;
  var majorIDSelector = $(this).attr("id").replace("major", "major_id")
  $('#' + majorIDSelector).val(selectedMajorID)
});

function loadMajorList(selectID, universityID, readonly) {
  const $select2Selector = $('#' + selectID);
  $select2Selector.addClass('major-selector')
  if (universityID == 0) {
    $select2Selector.select2({
      theme: 'bootstrap',
      data: [{id: 'Lainnya', text: 'Lainnya', majorId: 0}]
    });
    $select2Selector.trigger('change');
  } else {

    path_url = '/api/v1/university';
    if (window.location.host === 'app.ruangguru.com') {
      path_url = '/form/api/v1/university';
    } else {
      path_url = '/api/v1/university';
    }

    $select2Selector.select2({
      theme: 'bootstrap',
      ajax: {
        type: 'get',
        url: path_url + '/'+ universityID + '/majors',
        dataType: 'json',
        data: function (params) {
          return {
            query: params.term // search term
          };
        },
        processResults: function (data) {
          if(data.data.length > 0) {
            return {
              results: $.map(data.data, function (item) {
                return {
                  text: item.name,
                  id: item.name,
                  majorId: item.ID
                }
              })
            };
          } else {
            if ($select2Selector.data("major-other")) {
              return {
                results: [{
                  text: 'Lainnya',
                  id: 'Lainnya',
                  majorId: 0
                }]
              }
            } else {
              return { results: [] }
            }
          }
        }
      }
    });
  }
  

  $select2Selector.prop("readonly", readonly);
}

$('.major-selector').each(function() {
  if ($(this).attr('data-dependent-field-visibility') === 'hidden') {
    $(this).next(".select2-container").addClass('d-none');
  }
});
